module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/about/1-mobile-3a3b73daead89c0f7fe6646f6b00eef1.jpg";